export const apiRoutes = {
  getCounties: `/counties`,
  getCities: `/cities`,
  getVillages: `/villages`,
  getObjectItems: `/object-items`,
  getContracts: `/contracts`,
  getInvoices: `/invoices`,
  getWaypoints: `/waypoints`,
  getHelpdeskTicketTypes: '/odoo/tickets/types',
  getHelpdeskTickets: '/odoo/tickets/',
  createHelpdeskTicket: '/odoo/tickets',
  getInvoicePdf: (invoiceNo: string) => `/invoices/${invoiceNo}/saf-pdf`,
  getHelpdeskTicketMessages: (ticketId: number) => `/odoo/tickets/${ticketId}/messages`,
  createHelpdeskTicketMessage: (ticketId: number) => `/odoo/tickets/${ticketId}/messages`,
  updateContainerCoordinates: `/objects/items/coordinates`,
  getRouteGroupItems: '/route-group-items',
  getRouteGroupItemWaypoints: '/route-group-item-waypoints',
  refreshToken: '/self-service/auth/refresh',
};
